import React from 'react';
export function TrustBar() {
  const metrics = [{
    label: 'Turnaround',
    value: '48h'
  }, {
    label: 'Varianten',
    value: 'Unlimited'
  }, {
    label: 'Qualität',
    value: 'Exposé-ready'
  }];
  return <section className="py-12 border-y border-black/5 bg-white" data-id="element-224">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-225">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12" data-id="element-226">
          {/* Logos */}
          <div className="flex flex-wrap justify-center lg:justify-start gap-8 opacity-40 hover:opacity-60 transition-all duration-500" data-id="element-227">
            {[1, 2, 3, 4, 5].map(i => <div key={i} className="h-8 w-32 bg-neutral-100 border border-neutral-200 rounded flex items-center justify-center" data-id="element-228">
                <span className="text-xs font-medium text-neutral-400 uppercase tracking-widest" data-id="element-229">
                  Kunde {i}
                </span>
              </div>)}
          </div>

          {/* Metrics */}
          <div className="flex items-center gap-8 sm:gap-12" data-id="element-230">
            {metrics.map(metric => <div key={metric.label} className="text-center lg:text-right" data-id="element-231">
                <p className="text-2xl sm:text-3xl font-semibold text-black" data-id="element-232">
                  {metric.value}
                </p>
                <p className="text-xs sm:text-sm font-light text-neutral-400 uppercase tracking-wide mt-1" data-id="element-233">
                  {metric.label}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}